import { ErrorCode } from '@app/origami-api/constants/error-codes';

export function getAttachmentPaths(files: any[]): string[] {
  return files.reduce<string[]>((result, file) => {
    if (file.response && file.response.ErrorCode === ErrorCode.SUCCESS && file.response.Result) {
      result.push(file.response.Result.FileToken);
    }
    return result;
  }, []);
}

export function getFixedEmailForSearch(email: string): string {
  const eml = email || '';

  return eml.replace(/'/, "''");
}

export function convertHtmlToPlainText(html: string): string {
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.textContent || div.innerText;
}
